import {
    datePickerHelper,
    multiSelectHelper,
    onChangeCaretHelper,
    typeaheadHelper
} from './helpers';
import Checkbox from '../Checkbox/Checkbox';
import DatePicker from '../DatePicker/DatePicker';
import DateRangePicker from '../DateRangePicker/DateRangePicker';
import Input from '../Input/Input';
import MultiSelect from '../MultiSelect/MultiSelect';
import Password from '../Password/Password';
import Radio from '../Radio/Radio';
import Select from '../Select/Select';
import TextArea from '../TextArea/TextArea';
import AITimeSlotPicker from '../TimeSlotPicker/AITimeSlotPicker';
import TimeSlotPicker from '../TimeSlotPicker/TimeSlotPicker';
import Typeahead from '../Typeahead/Typeahead';

import { formatPhone, numbers } from '$Validation/Normalizer';

export const config = {
    birthdate: {
        component: DatePicker,
        onChange: datePickerHelper
    },
    checkbox: { component: Checkbox },
    date: {
        component: DatePicker,
        onChange: datePickerHelper
    },
    dateRange: {
        component: DateRangePicker,
        onChange: datePickerHelper
    },
    number: {
        component: Input,
        onChange: onChangeCaretHelper(numbers),
        inputMode: 'numeric'
    },
    hidden: {
        component: props => <input type="hidden" {...props} />
    },
    password: { component: Password },
    // Ant's CheckGroup is weird -- we may want to create our own
    // Using their individual checkboxes
    // multicheck: { component: MultiCheckFormatted },
    radio: { component: Radio },
    select: {
        component: Select
    },
    text: { component: Input },
    email: { component: Input },
    tel: {
        component: Input,
        fieldProps: {
            placeholder: '(555) 555-5555'
        },
        onChange: onChangeCaretHelper(formatPhone)
    },
    textArea: {
        component: TextArea,
        fieldProps: {
            rows: 4
        }
    },
    timeSlotPicker: {
        component: TimeSlotPicker
    },
    aiTimeSlotPicker: {
        component: AITimeSlotPicker
    },
    typeahead: {
        component: Typeahead,
        onChange: typeaheadHelper
    },
    multiSelect: {
        component: MultiSelect,
        onChange: multiSelectHelper
    }
};
